// extracted by mini-css-extract-plugin
export default {"breadcrumbList":"breadcrumb_breadcrumbList__ZP627","breadcrumbItem":"breadcrumb_breadcrumbItem__btwUQ","separator":"breadcrumb_separator__Ck+S0"};